import styled from 'styled-components';
import { FaStar } from 'react-icons/fa';
import { yellowStar } from '../../constants';

export const StyledFaStar = styled(FaStar)`
    color: ${yellowStar};
`;
